"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const components_1 = require("../../../components");
const PrimaryButton_1 = __importDefault(require("../../../components/button/PrimaryButton"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const styles_1 = __importDefault(require("./styles"));
const ConfirmForgot = (props) => {
    const { email } = props?.route?.params;
    return (react_1.default.createElement(react_native_1.Pressable, { style: {
            flex: 1,
            backgroundColor: "#F7F7F7",
            justifyContent: "space-between",
        }, onPress: react_native_1.Keyboard.dismiss, disabled: helpler_1.isWeb },
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, titleStyle: {
                    alignSelf: "center",
                    paddingRight: (0, scale_1.scale)(20),
                    fontSize: 14,
                }, title: "パスワードを忘れた方", styleContainer: {
                    backgroundColor: Colors_1.default.white,
                }, onLeftPress: rootNavigation_1.goBack }),
            react_1.default.createElement(react_native_1.KeyboardAvoidingView, null,
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.main },
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row" } },
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.Rectangle }),
                        react_1.default.createElement(CustomText_1.default, { style: {
                                fontSize: (0, scale_1.moderateScale)(15),
                                lineHeight: (0, scale_1.moderateScale)(23),
                                color: "#292A33",
                                fontWeight: "300",
                                paddingLeft: (0, scale_1.scale)(8),
                            } }, "\u6848\u5185\u30E1\u30FC\u30EB\u9001\u4FE1\u5B8C\u4E86")),
                    react_1.default.createElement(CustomText_1.default, { style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: "#292A33",
                            fontWeight: "300",
                            marginTop: 12,
                        } },
                        email,
                        "\u5B9B\u3066\u306B\u30D1\u30B9\u30EF\u30FC\u30C9\u518D\u8A2D\u5B9A\u306E\u6848\u5185\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F\u3002"),
                    react_1.default.createElement(CustomText_1.default, { style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: "#292A33",
                            fontWeight: "300",
                        } }, "\u9001\u4FE1\u3055\u308C\u305F\u30E1\u30FC\u30EB\u306BURL\u304C\u8A18\u8F09\u3055\u308C\u3066\u3044\u307E\u3059\u306E\u3067URL\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u30D1\u30B9\u30EF\u30FC\u30C9\u518D\u8A2D\u5B9A\u753B\u9762\u304B\u3089\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row" } },
                        react_1.default.createElement(CustomText_1.default, { style: {
                                fontSize: (0, scale_1.moderateScale)(12),
                                lineHeight: (0, scale_1.moderateScale)(23),
                                color: "#292A33",
                                fontWeight: "300",
                            } }, "\u203B"),
                        react_1.default.createElement(CustomText_1.default, { style: {
                                fontSize: (0, scale_1.moderateScale)(12),
                                lineHeight: (0, scale_1.moderateScale)(23),
                                color: "#292A33",
                                fontWeight: "300",
                            } }, "XXXXXXXXXX@XXXXX\u304B\u3089\u30E1\u30FC\u30EB\u3092\u53D7\u4FE1\u3067\u304D\u308B\u72B6\u614B\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002")),
                    react_1.default.createElement(PrimaryButton_1.default, { onPress: () => {
                            props.navigation.navigate("CHANGE_PASSWORD", { email: email });
                        }, title: "\u30ED\u30B0\u30A4\u30F3\u753B\u9762\u306B\u623B\u308B", textStyle: { color: '#1960B0', fontWeight: '300' }, style: styles_1.default.buttonSend }))))));
};
exports.default = ConfirmForgot;
